import { useLocation } from 'react-router-dom';
import { useMemo } from 'react';
import { getListingUrl } from '../../utils/RoutingUtils';
import { getPlaylistUrl } from '../playlist/playlistRouting';
export const useLearningContentCardTo = ({
  item: {
    id,
    type,
    language,
    progress
  },
  overviewType,
  playlistId,
  showOverview
}) => {
  const location = useLocation();
  const {
    pathname,
    search
  } = location;
  const isStarted = progress && progress.status !== 'NOT_STARTED';
  const to = useMemo(() => {
    if (type === 'PLAYLIST' || type === 'LEARNING_PATH') {
      return getPlaylistUrl(id);
    }
    return getListingUrl({
      type: type,
      isStarted: showOverview !== undefined ? !showOverview : !!isStarted,
      id,
      language: language,
      currentPathname: pathname,
      currentSearch: search,
      appearsIn: overviewType,
      playlistId
    });
  }, [id, isStarted, language, overviewType, pathname, playlistId, search, showOverview, type]);
  return Object.assign({}, to, {
    state: {
      backLocation: location
    }
  });
};